// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"cf688843","713":"8c5f9f1f","759":"908fe455"}[chunkId] + ".chunk.js";
};